import { NOTIFICATION_ACTION_MAPPER } from "@circle-react-shared/Notifications/List/Item/constants";
import { useNotificationContext } from "@circle-react-shared/Notifications/NotificationContext";
import { useNotificationsActions } from "@circle-react-shared/Notifications/useHeaderNotificationsApi";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";
import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";
import { Icon } from "@/react/components/shared/Icon";

import { IconButton } from "../../IconButton";

export const MarkAsReadButton = () => {
  const toast = useToast();
  const { setLastMarkedAsRead } = useNotificationContext();

  const onSuccess = (data: any) => {
    toast.success(t("header_v3.notifications_marked_as_read"));
    if (data.success) {
      const lastMarkedAsReadTime = new Date(data?.read_at_time).getTime();
      setLastMarkedAsRead(lastMarkedAsReadTime);
    }
  };

  const {
    mutate: performNotificationAction,
    isLoading: areNotificationsBeingMarkedAsRead,
  } = useNotificationsActions(onSuccess);

  if (areNotificationsBeingMarkedAsRead) {
    return (
      <div className="bg-secondary flex size-6 items-center justify-center rounded-sm">
        <Icon type="live-spinner" className="size-4 animate-spin" />
      </div>
    );
  }

  return (
    <TippyV2 interactive={false} content={t("header_v3.mark_all_as_read")}>
      <IconButton
        name="16-mark-as-read"
        onClick={() =>
          performNotificationAction({
            action: NOTIFICATION_ACTION_MAPPER.markAllAsRead,
          })
        }
        ariaLabel={t("header_v3.mark_all_as_read")}
        iconClassName="!text-dark"
      />
    </TippyV2>
  );
};
